import { I18n } from "@assets/strings";
import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { usePrivacyValidated } from "@domain/privacy/hooks";
import { RadioButton } from "@ui/components/inputs/radio";
import { gap } from "@ui/styles/utils";

type PrivacyEditorProps = React.HTMLAttributes<HTMLDivElement>;
export const PrivacyEditor: React.FC<PrivacyEditorProps> = ({ ...htmlProps }) => {
	const privacyValidated = usePrivacyValidated();
	const { privacyService } = useServices();

	return (
		<Container {...htmlProps}>
			<RadioButton
				checkbox
				id="privacy"
				name="privacy"
				checked={privacyValidated}
				onChange={() => {
					if (!privacyValidated) {
						privacyService.acceptPrivacy();
					}
				}}
			/>
			<div>
				<span>{I18n.t("register.cgu.accept")}</span>
				<Link to={Path.Cgu} target="_blank" rel="noreferrer">
					{I18n.t("register.cgu.link")}
				</Link>
			</div>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	${gap(10, "row")};
	${({ theme }) => theme.textStyles.light};

	> :first-child {
		flex-shrink: 0;
	}

	color: ${({ theme }) => theme.colors.textPrimary};

	a {
		text-decoration: underline;
	}
`;
